import React, { Component } from 'react'
import _ from 'lib/lodash'

import FeedbackCardItem from './FeedbackCardItem'
import CardListHeader from '../../common/list/v1/CardListHeader'

import './FeedbackCardList.css'

class FeedbackCardList extends Component {
	render() {
		const { actionHandler, nodes, title, aclAllow } = this.props;

		// filter for valid storage entries and reverse nodes to have newest on top
		const renderCards = () => _.map(nodes, (node, key) => (
			<FeedbackCardItem
				key={key}
				node={node}
				actionHandler={actionHandler}
				allowEdit={aclAllow.edit !== "none"}
			/>
		)).reverse();

		return (
			<section>
				<CardListHeader
					nodes={nodes}
					actionHandler={actionHandler}
					title={title}
					titleOne="Ihr Feedback"
					titleMany="Ihr Feedback"
					showCount={false}
					aclAllow={aclAllow}
				/>
				<div className="md-list-unstyled feedback-card-list-items">
					{renderCards()}
				</div>
			</section>
		);
	}
}

export default FeedbackCardList;



// WEBPACK FOOTER //
// ./src/components/cards/feedback/default/FeedbackCardList.jsx